import React, { useState, useEffect } from "react";
import { Select, message, Modal } from "antd";
import { connect } from "dva";
import { InvoiceStatusColorMap } from "@/utils/enum";
import { changeInvoiceStatus } from "@/services/quotes_new";

const { Option } = Select;
const { confirm } = Modal;

const LoadPaymentStatusSelect = ({ status, dealerName, paymentId, actionRef, updatePageData, configPerm }) => {
  const [prevStatusValue, setPrevStatusValue] = useState(status);
  const [statusValue, setStatusValue] = useState(status);

  // Sync statusValue with the status prop if it changes
  useEffect(() => {
    setPrevStatusValue(status);
    setStatusValue(status);
  }, [status]);

  const updateLoadPaymentStatus = value => {
    confirm({
      title: "Are you sure?",
      content: `Are you sure you want to update the pricing status for ${dealerName}'s load?`,
      onOk: () => {
        const hide = message.loading("Updating load payment status...");
        setStatusValue(value);
        changeInvoiceStatus(paymentId, { invoiceStatus: value }).then(res => {
          hide();
          if (!res || res.error) {
            message.warning("Can't update load payment status");
            setStatusValue(prevStatusValue); // Revert to previous value on error
            return;
          }
          message.success("Updated load payment status!");
          setPrevStatusValue(value); // Update prevStatusValue
          actionRef?.current?.reload() || updatePageData?.(); // Refresh data if possible
        });
      },
    });
  };

  if (!configPerm["CoreService.Payments.ChangeStatus"]) {
    return <p>{InvoiceStatusColorMap[statusValue]?.label}</p>;
  }

  return (
    <Select style={{ width: 150 }} value={statusValue} onChange={value => updateLoadPaymentStatus(value)}>
      {Object.keys(InvoiceStatusColorMap).map(statusKey => (
        <Option key={statusKey} value={+statusKey}>
          <span style={{ color: InvoiceStatusColorMap[statusKey].color }}>
            {InvoiceStatusColorMap[statusKey].label}
          </span>
        </Option>
      ))}
    </Select>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(LoadPaymentStatusSelect);
